// import imagesLoaded from 'imagesloaded';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import FrameAnimation from './frameAnimation';
import Helpers from './helpers';

gsap.registerPlugin(ScrollTrigger);

export default class {
  constructor() {
    this.concept = '#js-concept';
    this.characters = document.querySelectorAll('.js-concept-character');
    this.arrow = '.js-concept-arrow';
    this.message = '.js-concept-message';
    this.tl = null;
  }

  init() {
    this.setScrollTrigger();
    this.setInitialAnimation();
    this.runCharacterAnimations();
  }

  setScrollTrigger() {
    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.concept,
        start: 'top top',
        end: '+=150%',
        scrub: true,
        pin: true,
      },
    });
  }

  setInitialAnimation() {
    this.tl.set(this.arrow, {
      scaleY: 1,
      transformOrigin: 'bottom',
    });
    this.tl.set(this.message, {
      opacity: 0,
      y: 40,
    });
  }

  runCharacterAnimations() {
    this.characters.forEach((character) => {
      const frameAnimation = new FrameAnimation(character);
      frameAnimation.move();
      if (!character.classList.contains('-image01') && !character.classList.contains('-image06')) {
        this.tl.set(character, {
          opacity: 0,
          x: 0,
        });
      }
    });
    this.tl.to('.js-concept-character.-image01', {
      duration: 0.7,
      opacity: 0,
      css: {
        display: 'none',
      },
    });
    this.tl.to('.js-concept-character.-image06', {
      duration: 1,
      css: {
        display: 'block',
      },
    });
    this.tl.to(this.arrow, {
      duration: 1,
      scaleY: 0,
    }, '-=1');
    this.animateCharacters();
    this.tl.to(this.message, {
      duration: 1,
      opacity: 1,
      y: 0,
    });
  }

  animateCharacters() {
    const characterAnimations = [
      { className: '.js-concept-character.-image04' },
      { className: '.js-concept-character.-image05' },
      { className: '.js-concept-character.-image03' },
      { className: '.js-concept-character.-image02' },
    ];

    characterAnimations.forEach((animation) => {
      const elem = document.querySelector(animation.className);
      const computedStyle = getComputedStyle(elem);
      const initialValue = Helpers.getTranslateX(computedStyle.transform);
      gsap.set(animation.className, { x: 0 });
      this.tl.to(animation.className, {
        duration: 1,
        opacity: 1,
        x: initialValue,
      }, '-=1');
    });
  }
}
